export const addIubendaCookieBanner = (notice, url) => {
  if (notice == true && url) {
    let script = [
      {
        src: url,
        type: "text/javascript",
      },
    ];

    useHead({
      script: script,
    });
  }
};
